export default __webpack_public_path__ + "static/media/home-split-portfolio-img-02.37e571bc.jpg";